import { Card } from '@mui/material';
import { styled } from '@mui/material';

const AppCard = styled(Card)(({ theme }) => ({
    background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%)`,
    borderRadius: theme.spacing(2.5),
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    border: `1px solid ${theme.palette.divider}30`,
    overflow: 'hidden',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
}));

export default AppCard;
